import produce from 'immer';
import { Reducer } from 'redux';

import { MeetingsMap, MeetingsState, MeetingsTypes, MeetingType } from '../types';

const initialState: MeetingsState = {
    isLoading: false,
    meetings: { [MeetingType.Confirmed]: {}, [MeetingType.Cancelled]: {} },
};

const updateMeetingNote = (meetingId: string, note: string, meetings: MeetingsMap) => {
    const meetingConfirmed = Object.values(meetings[MeetingType.Confirmed]);

    const updatedMeetingsMap: MeetingsMap = {
        ...meetings,
        [MeetingType.Confirmed]: Object.fromEntries(
            Object.entries(meetings[MeetingType.Confirmed]).map(([key], index) => [
                key,
                meetingConfirmed.map((meetingRow) =>
                    meetingRow.map((meeting) =>
                        meeting.id === meetingId ? { ...meeting, meetingNote: note } : meeting,
                    ),
                )[index],
            ]),
        ),
    };
    return updatedMeetingsMap;
};

const meetingsReducer: Reducer<MeetingsState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case MeetingsTypes.GET_LIST_MEETINGS: {
                draft.isLoading = false;
                draft.error = undefined;
                draft.meetings = action.payload.meetings;
                break;
            }
            case MeetingsTypes.REQUEST_GET_LIST_MEETINGS: {
                draft.isLoading = true;
                draft.error = undefined;
                break;
            }
            case MeetingsTypes.UPDATE_MEETING_NOTE: {
                draft.isLoading = false;
                draft.meetings = updateMeetingNote(action.payload.meetingId, action.payload.note, state.meetings);
                break;
            }
            case MeetingsTypes.MEETINGS_ERROR: {
                draft.isLoading = false;
                draft.error = action.payload.error;
                break;
            }
            case MeetingsTypes.CLEAR_MEETINGS_ERROR: {
                draft.error = undefined;
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

export { meetingsReducer };
